import { appPermissions } from '@/libs/auth/permissions/appPermissions';
import { beforeEnterCheckPermission } from './utils/routePermissions';

export default [
  {
    name: 'category',
    path: '/category',
    component: () => import('@/views/category/Category.vue'),
    meta: {
      title: 'التصنيفات',
    },
    beforeEnter(to, from, next) {
      const { has, redirectTo } = beforeEnterCheckPermission(
        appPermissions.category,
      );
      if (has) return next();
      else return next(redirectTo);
    },
  },
];
